import { EVENT_NAME as ContextEventName } from '@adobe-fonts/site/components/contextual-help/ContextualHelp.js';
import {EVENT_NAME as SearchParamChangedEvent } from '@adobe-fonts/site/events/SearchParamChangedEvent.js';
import {EVENT_NAME as UservoiceEvent} from '@adobe-fonts/site/events/UservoiceEvent.js';

import { initI18n } from '../util/activation_util.js';
import { addPageAction, getNewRelicName } from '../util/new_relic.js';

const abortController = new AbortController();
const sitewideHeader = document.querySelector('#sitewide-header');
const headerSearch = sitewideHeader.querySelector('#header-search');
let page = 'font-discovery-search';

function init() {
  initI18n();
  initAnalyticsEvents();
}

function initAnalyticsEvents() {
  const resultsHeader = document.querySelector('.font-discovery__results-header');

  if (resultsHeader) {
    page = 'font-discovery-results';
    initResultsEvents();
  } else {
    const allTags = document.querySelector('[data-analytics-class="tag-container"]');
    if (!allTags) {
      return;
    }

    allTags.addEventListener('click', function handleTags(event) {
      const trackingLink = event.target.closest('[data-analytics-class*="font-discovery-card tag-card"]');

      if (!trackingLink) {
        return;
      }

      const name = getNewRelicName(page, event, 'tags');
      addPageAction(name, { slug: trackingLink.slug });
    }, { once: true });

    initSearchChangeEvents();
  }

  // Unload event
  window.addEventListener('beforeunload', () => {
    addPageAction(`typekit.${page}.page_exit`);

    // remove event listeners that could happen more than once
    // (i.e. listeners that do not navigate users away from the current page)
    abortController.abort();
  });
}

function initResultsEvents() {
  const pillsContainer = document.querySelector('.font-discovery__results-pills-container');
  const results = document.querySelector('#results');

  initSearchChangeEvents();

  if (headerSearch) {
    headerSearch.addEventListener('click', (event) => addPageAction(getNewRelicName(page, event, 'search-bar')), { signal: abortController.signal });
  }

  if (pillsContainer) {
    pillsContainer.addEventListener('click', (event) => handleLinkClickEvent(event, 'search-pill-button', page), { once: true });
  }

  document.addEventListener(ContextEventName, (event) => handleContextualHelpClick(event), { signal: abortController.signal });

  if (results) {
    results.addEventListener('click', (event) => handleLinkClickEvent(event, 'view-all'), { signal: abortController.signal });

    results.addEventListener('click', (event) => handleLinkClickEvent(event, 'bottom-all-fonts-link'), { signal: abortController.signal });

    results.addEventListener('click', (event) => handleLinkClickEvent(event, 'font-discovery-card'), { signal: abortController.signal });
  }
}

/**
 * Add the uservoice event listener after contextual help event has fired
 */
function handleContextualHelpClick(event) {
  addPageAction(getNewRelicName(page, event));
  addUservoiceEventListener();
}

function addUservoiceEventListener() {
  document.addEventListener(UservoiceEvent, (event) => addPageAction(getNewRelicName(page, event)), { signal: abortController.signal });
}

function initSearchChangeEvents() {
  if (headerSearch) {
    headerSearch.addEventListener(SearchParamChangedEvent, (event) => addPageAction(getNewRelicName(page, event)), { once: true });
  }
}

/**
 * Send a link (href) click event to New Relic based on the closest data-analytics-class
 * @param {Event} event
 * @param {String} dataClass
 */
function handleLinkClickEvent(event, dataClass) {
  const trackingCard = event.target.closest(`[data-analytics-class*=${dataClass}]`);
  if (!trackingCard) {
    return;
  }

  addPageAction(getNewRelicName(page, event, dataClass), {
    elementUrl: trackingCard.href,
    elementClass: trackingCard.dataset.analyticsClass
  });
}

export { init };
